const WSRoomNames = [
  { roomName: 'sigevents', programId: 1 },
  { roomName: 'shelters', programId: 2 },
  { roomName: 'resourcerequests', programId: 3 },
  { roomName: 'resourcerequests/uploadData', programId: 3 },
  // { roomName: 'notifications', programId: 4 },
  { roomName: 'units', programId: 5 },
  { roomName: 'units/updateWithRelational', programId: 5 },
  { roomName: 'units/resetUnits', programId: 5 },
  { roomName: 'incidents', programId: 7 },
  { roomName: 'incidents2groups', programId: 7 },
  { roomName: 'positionlogs', programId: 8 },
  { roomName: 'eventjournal', programId: 9 },
  { roomName: 'missions', programId: 10 },
  { roomName: 'mission2subtasks', programId: 10 },
  // { roomName: 'battlerhythm', programId: 18 },
  { roomName: 'dockets', programId: 13 },
  { roomName: 'dockets', programId: 15 },
  // { roomName: 'battlerhythm', programId: 21 },
  { roomName: 'countyclosures/putCountyClosuresForDate', programId: 22 },
  { roomName: 'eocstatuses', programId: 23 },
  { roomName: 'eocstatuses/resetAll', programId: 23 },
  { roomName: 'commchecks', programId: 24 },
  { roomName: 'publicinformation', programId: 25 },
  { roomName: 'afteractionreports', programId: 27 },
  { roomName: 'trafficcontrolpoint/updateData', programId: 29 },
  { roomName: 'trafficcontrolpoint', programId: 29 },
  { roomName: 'fieldreports', programId: 30 },
  { roomName: 'volunteers', programId: 31 },
  { roomName: 'inventory/updateData', programId: 33 },
  { roomName: 'inventory', programId: 33 },
  { roomName: 'donations', programId: 34 },
  { roomName: 'massfeeding/updateData', programId: 35 },
  { roomName: 'disasterrecoverycenters/updateData', programId: 36 },
  { roomName: 'debrissites', programId: 38 },
  { roomName: 'mutualaidchannels', programId: 39 },
  { roomName: 'fpcons', programId: 42 },
  { roomName: 'fpcons/createOrUpdate', programId: 42 },
  { roomName: 'fpcon2timestamps', programId: 42 },
  { roomName: 'fpcontemplates', programId: 42 },
  { roomName: 'aircraft', programId: 43 },
  { roomName: 'aircraftstatus_lite', programId: 43 },
  { roomName: 'hospital_contacts', programId: 44 },
  { roomName: 'hospitalservices/createOrUpdateBatch', programId: 44 },
  { roomName: 'hospitalbedcollections/createOrUpdateBatch', programId: 44 },
  { roomName: 'hospitalequipment/createOrUpdateBatch', programId: 44 },
  { roomName: 'remspotreports', programId: 49 },
  { roomName: 'pointofinterest', programId: 50 },
  { roomName: 'incidentjournal', programId: 51 },
  { roomName: 'msel-entry-save-response', programId: 75 },
  { roomName: 'msel-incident-update-response', programId: 75 },
  { roomName: 'mselinfo', programId: 75 },
  { roomName: 'locationservices', programId: 76 },
  { roomName: 'localfacilities', programId: 77 },
  { roomName: 'checklists', programId: 82 },
  { roomName: 'tasks', programId: 84 },
  { roomName: 'tasks/createOrUpdate', programId: 84 },
  { roomName: 'crass', programId: 85 },
  { roomName: 'wastewater', programId: 86 },
  { roomName: 'wastewatercontacts', programId: 86 },
  { roomName: 'wastewater/resetSurveys', programId: 86 },
  { roomName: 'callcenters', programId: 90 },
  { roomName: 'lifelines', programId: 91 },
  { roomName: 'distributionlists/updateData', programId: 94 },
  { roomName: 'countyfeeding', programId: 96 },
  { roomName: 'countyfeedingmeals', programId: 96 },
  { roomName: 'pointsofdispensing', programId: 98 },
  { roomName: 'pointsofdispensing/updateData', programId: 98 },
  { roomName: 'eocstatuses', programId: 100 },
  { roomName: 'eocstatuses/resetAll', programId: 100 },
];

export default WSRoomNames;
